import React, {Component} from 'react'

import ScrollerMobileDotComponent from './ScrollerMobileDot.component'

class ScrollerMobileDotContainer extends Component {
    handleClick = (evt) => {
      this.props.handleScrollDotClick(this.props.dotNumber)
    }

    render() {
      return (
        <ScrollerMobileDotComponent handleClick={this.handleClick} active={this.props.active} />
      )
    }
}

export default ScrollerMobileDotContainer
